
import { jsPDF } from "jspdf";
import { PdfSectionOptions } from "../types";
import { getScoreInterpretation, addScoreVisualization } from "../scoreUtils";

/**
 * Add results assessment section
 */
export const addAssessmentResults = ({ doc, pageWidth, y }: PdfSectionOptions, percentage: number): number => {
  // Add score section
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(16);
  doc.text("Readiness Assessment Results", 15, y);
  
  doc.setDrawColor(200, 200, 200);
  doc.line(15, y + 5, pageWidth - 15, y + 5);
  
  // Add score visualization - pass all required parameters
  const newY = addScoreVisualization({ 
    doc, 
    percentage, 
    pageWidth, 
    y: y + 25 
  });
  
  // Score interpretation
  doc.setFontSize(12);
  doc.text("What this means:", 15, newY);
  
  const scoreInterpretation = getScoreInterpretation(percentage);
  
  doc.setFontSize(11);
  const textLines = doc.splitTextToSize(scoreInterpretation, pageWidth - 30);
  doc.text(textLines, 15, newY + 10);
  
  return newY + 10 + (textLines.length * 5) + 10;
};
